import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, Output, NgModule } from '@angular/core';
import * as i1$1 from 'ngx-bootstrap/datepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslationModule } from '@niceltd/cxone-components/translation';
import { ComponentKeys } from '@niceltd/cxone-components/shared-services';
import { I18NEXT_NAMESPACE } from 'angular-i18next';
const _c0 = a0 => ({
  "selected": a0
});
function ToggleButtonGroupComponent_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function ToggleButtonGroupComponent_button_1_Template_button_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r3);
      const toggleButton_r1 = restoredCtx.$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onValueChange(toggleButton_r1));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const toggleButton_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", toggleButton_r1.name)("ngClass", i0.ɵɵpureFunction1(4, _c0, ctx_r0.buttonGroupModel === toggleButton_r1));
    i0.ɵɵattribute("aria-label", toggleButton_r1.name + (ctx_r0.buttonGroupModel === toggleButton_r1 ? " selected" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(toggleButton_r1.name);
  }
}
class ToggleButtonGroupComponent {
  constructor() {
    this.options = [];
    this.onSelectedChange = new EventEmitter();
    this.buttonGroupModel = null;
  }
  ngOnInit() {
    if (!this.options.length) {
      return;
    }
    if (!this.initialValue) {
      this.initialValue = this.options[0];
    } else {
      this.initialValue = this.options.find(item => item === this.initialValue) || this.options[0];
    }
    this.buttonGroupModel = this.initialValue;
    this.onValueChange(this.buttonGroupModel);
  }
  onValueChange(toggleButton) {
    this.buttonGroupModel = toggleButton;
    this.onSelectedChange.emit(this.buttonGroupModel);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function ToggleButtonGroupComponent_Factory(t) {
      return new (t || ToggleButtonGroupComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ToggleButtonGroupComponent,
      selectors: [["toggle-button-group"]],
      inputs: {
        initialValue: "initialValue",
        options: "options"
      },
      outputs: {
        onSelectedChange: "onSelectedChange"
      },
      decls: 2,
      vars: 1,
      consts: [[1, "btn-group", "button-toggle-group"], ["class", "toggle-button", "tabindex", "0", 3, "name", "ngClass", "click", 4, "ngFor", "ngForOf"], ["tabindex", "0", 1, "toggle-button", 3, "name", "ngClass", "click"]],
      template: function ToggleButtonGroupComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, ToggleButtonGroupComponent_button_1_Template, 2, 6, "button", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.options);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf],
      styles: [".button-toggle-group{display:flex;margin:5px 0;box-shadow:0 1px 2px 2px #00000008}.button-toggle-group .toggle-button{display:flex;height:30px;flex-grow:1;justify-content:center;align-items:center;background:#fff;border:1px solid rgba(46,46,46,.0509803922)}.button-toggle-group .toggle-button:first-child{border-right:none;border-radius:2px 0 0 2px}.button-toggle-group .toggle-button:last-child{border-left:none;border-radius:0 2px 2px 0}.button-toggle-group .toggle-button:hover{background-color:#f5f8fa}.button-toggle-group .toggle-button.selected{background-color:#daeaf7;border-bottom:1px solid #526B7A;border-top:1px solid #B7C4CF;border-right:1px solid #B7C4CF;border-left:1px solid #B7C4CF}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToggleButtonGroupComponent, [{
    type: Component,
    args: [{
      selector: 'toggle-button-group',
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"btn-group button-toggle-group\">\n  <button class=\"toggle-button\" *ngFor=\"let toggleButton of options\" [name]=\"toggleButton.name\"\n          [attr.aria-label]=\"toggleButton.name + ((buttonGroupModel === toggleButton) ? ' selected': '')\" tabindex=\"0\"\n          [ngClass]=\"{'selected': buttonGroupModel === toggleButton}\" (click)=\"onValueChange(toggleButton)\">{{toggleButton.name}}</button>\n</div>\n",
      styles: [".button-toggle-group{display:flex;margin:5px 0;box-shadow:0 1px 2px 2px #00000008}.button-toggle-group .toggle-button{display:flex;height:30px;flex-grow:1;justify-content:center;align-items:center;background:#fff;border:1px solid rgba(46,46,46,.0509803922)}.button-toggle-group .toggle-button:first-child{border-right:none;border-radius:2px 0 0 2px}.button-toggle-group .toggle-button:last-child{border-left:none;border-radius:0 2px 2px 0}.button-toggle-group .toggle-button:hover{background-color:#f5f8fa}.button-toggle-group .toggle-button.selected{background-color:#daeaf7;border-bottom:1px solid #526B7A;border-top:1px solid #B7C4CF;border-right:1px solid #B7C4CF;border-left:1px solid #B7C4CF}\n"]
    }]
  }], null, {
    initialValue: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    onSelectedChange: [{
      type: Output
    }]
  });
})();
class ToggleButtonGroupModule {
  /** @nocollapse */static {
    this.ɵfac = function ToggleButtonGroupModule_Factory(t) {
      return new (t || ToggleButtonGroupModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ToggleButtonGroupModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: I18NEXT_NAMESPACE,
        useValue: ComponentKeys.TRANSLATION_NAMESPACE
      }],
      imports: [BsDatepickerModule.forRoot(), CommonModule, FormsModule, TranslationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToggleButtonGroupModule, [{
    type: NgModule,
    args: [{
      declarations: [ToggleButtonGroupComponent],
      imports: [BsDatepickerModule.forRoot(), CommonModule, FormsModule, TranslationModule],
      providers: [{
        provide: I18NEXT_NAMESPACE,
        useValue: ComponentKeys.TRANSLATION_NAMESPACE
      }],
      exports: [ToggleButtonGroupComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ToggleButtonGroupComponent, ToggleButtonGroupModule };
